import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { supplierLogin } from '../services/authService';
import { getApiErrorMessage } from '../utils/errorMessages';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await supplierLogin(values.email, values.password);
      message.success(t('loginSuccess'));
      navigate('/home');
    } catch (error: any) {
      message.error(getApiErrorMessage(error, 'loginError', t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #334E3B 0%, #C8CBC0 100%)'
    }}>
      <div style={{ position: 'fixed', top: 16, right: 16 }}>
        <LanguageSwitcher />
      </div>
      <Card style={{ width: 400, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          <Title level={2}>{t('login')}</Title>
          <Text type="secondary">{t('loginSubtitle')}</Text>
          
          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: t('emailRequired') },
                { type: 'email', message: t('emailInvalid') }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder={t('email')}
                size="large"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: t('passwordRequired') }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder={t('password')}
                size="large"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
              >
                {t('login')}
              </Button>
            </Form.Item>
          </Form>

          <Text>
            {t('noAccount')} <Link to="/register">{t('registerHere')}</Link>
          </Text>
        </Space>
      </Card>
    </div>
  );
};

export default Login;
